import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';

const useUrlWithEnv = () => {
  const selectedEnvId = useSelectedEnv();
  const getUrlWithEnv = (path: string) =>
    selectedEnvId ? `/${selectedEnvId}${path}` : path;

  return getUrlWithEnv;
};

export default useUrlWithEnv;
